// extracted by mini-css-extract-plugin
export default {"modal":"gfYlmIbQFdDKCiDMydyw","leftSideContentWrapper":"U9EysCrUsqxbQjVBnt8I","mainWrapper":"ajPJFCtXAQ9mzTKuADyX","mainContentWrapper":"vzT5V0mciIkp4_0TpZnI"};